import { VehicleIssue } from "./../models/dashboard-vehicle-status.model";
import { AdminDashboardService } from "./../models/admin-dashboard.service";
import { CompanyService } from "./../../company/models/company.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { SharedVehicleGroupModel } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { CompanyModel } from "./../../company/models/company.model";
import {
  InstanceModel,
  DashboardConfigModel
} from "./../../instance/models/instance.model";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { DropdownModel } from "../../report/models/report-filter.model";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { RoleLevel } from "../../shared/config";

@Component({
  selector: "admin-dashboard-filter",
  template: require('../views/admin-dashboard-filter.component.html'),
  providers: [InstanceService, CompanyService, SharedVehicleGroupService]
})
export class AdminDashboardFilterComponent implements OnInit {
  filterSamePositionValue: any;
  filterNotBookedValue: any;
  filterDashboardConfig: any;
  filterVehicleIssuePriorityList: any;
  filterSVGHashId: any;
  filterCompanyHashId: any;
  filterInstanceHashId: any;
  isDirty: boolean;
  @Output("OnSearch") onSearch = new EventEmitter();

  instanceHashId: string = "";
  companyHashId: string = "";
  sVGHashId: string = "";
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  sharedVehicleGroupList: DropdownModel[];
  vehicleIssuePriorityList: VehicleIssue[];
  dashboardConfig: DashboardConfigModel;
  notBookedValue: string = "";
  notBookedValueInterval: string = "";
  samePositionValue: string = "";
  samePositionValueInterval: string = "";
  apiErrorMsg: string;
  pageName: string;
  roleLevel = RoleLevel;
  constructor(
    private authService: AuthService,
    private adminDashboardService: AdminDashboardService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private sharedVehicleGroupService: SharedVehicleGroupService
  ) {}

  ngOnInit() {
    this.pageName = "Admin_Dashboard";
    this.RetriveFilter();    
    this.GetAllInstanceList();
  }

  public GetAllInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(
      res => {
        this.instanceList = res.data;
        if (this.instanceList && this.instanceList.length > 0) {
          if (this.filterInstanceHashId) {
            this.instanceHashId = this.filterInstanceHashId;
            this.filterInstanceHashId = null;
          } else {
            this.instanceHashId = this.instanceList[0].keyHash;
          }
          this.OnInstanceChange();
          this.OnSearch();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private RetriveFilter() {
    var filter = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      null
    );

    if (filter) {
      this.filterInstanceHashId = filter["instanceHashId"];
      this.filterCompanyHashId = filter["companyHashId"];
      this.filterSVGHashId = filter["svgHashId"];
      this.filterVehicleIssuePriorityList = filter["vehicleIssuePriorityList"];
      this.filterDashboardConfig = filter["dashboardConfig"];
      this.filterNotBookedValue = filter["notBookedValue"];
      this.filterSamePositionValue = filter["samePositionValue"];
    }
  }

  public GetAllCompanyList() {
    //this.companyService.GetCompanyList()
    this.companyService
      .GetDropdownCompanyList(this.pageName, this.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          if (this.filterCompanyHashId) {
            this.companyHashId = this.filterCompanyHashId;
            this.filterCompanyHashId = null;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  // Value should be null in case required all svg
  public GetAllSVGList() {
    // public GetAllSVGList(companyHashId?: string, instanceHashId?: string) {
    //this.adminDashboardService.GetSharedVehicleGroupList(companyHashId, instanceHashId)
    this.sharedVehicleGroupService
      .GetDropdownSVGList(
        this.pageName,
        this.companyHashId,
        this.instanceHashId
      )
      .subscribe(
        res => {
          this.sharedVehicleGroupList = res.data;

          if (this.filterSVGHashId) {
            this.sVGHashId = this.filterSVGHashId;
            this.filterSVGHashId = null;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCompanyListByInstance(instanceHashId: string) {
    this.companyService.GetCompanyByInstance(instanceHashId).subscribe(
      res => {
        this.companyList = res.data;
        if (this.filterCompanyHashId) {
          this.companyHashId = this.filterCompanyHashId;
          this.filterCompanyHashId = null;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetPriorityForIssues(instanceHashId: string) {
    this.adminDashboardService.GetPriorityForIssues(instanceHashId).subscribe(
      res => {
        this.vehicleIssuePriorityList = res.data.vehicleIssue;
        this.dashboardConfig = res.data.dashboardConfig;
        if (this.filterDashboardConfig) {
          this.dashboardConfig.defaultLocation = this.filterDashboardConfig.defaultLocation;
          this.dashboardConfig.defaultStatus = this.filterDashboardConfig.defaultStatus;
          this.filterDashboardConfig = null;
        }
        this.notBookedValue = res.data.notBookedValue;
        this.notBookedValueInterval = res.data.notBookedValueInterval;
        this.samePositionValue = res.data.samePositionValue;
        this.samePositionValueInterval = res.data.samePositionValueInterval;     
        this.PassDataToParent();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  // Event
  public OnInstanceChange() {
    //this.ResetValidSearch();
    if (this.instanceHashId) {
      //this.GetCompanyListByInstance(this.instanceHashId);
      this.GetAllCompanyList();
      this.companyHashId = "";
      this.OnCompanyChange();
    } else {
      this.companyList = [];
      this.sharedVehicleGroupList = [];
      this.companyHashId = "";
      this.sVGHashId = "";
    }
  }

  public OnCompanyChange() {
    //this.ResetValidSearch();
    //this.GetAllSVGList(this.companyHashId, this.instanceHashId);
    this.GetAllSVGList();
    this.sVGHashId = "";
  }

  // Button Click

  public PassDataToParent() {
    this.onSearch.emit({
      instanceHashId: this.instanceHashId,
      companyHashId: this.companyHashId,
      svgHashId: this.sVGHashId,
      vehicleIssuePriorityList: this.vehicleIssuePriorityList,
      dashboardConfig: this.dashboardConfig,
      notBookedValue: this.notBookedValue,
      samePositionValue: this.samePositionValue,
      notBookedValueInterval: this.notBookedValueInterval,
      samePositionValueInterval: this.samePositionValueInterval
    });
  }

  public OnSearch() {    
    if (!this.instanceHashId) {
      this.isDirty = true;
    } else {
      this.isDirty = false;
      this.GetPriorityForIssues(this.instanceHashId);    
    }
  }

  // AllowToDisplayInstanceDropDown() {
  //   if (this.instanceList) {
  //     if (this.instanceList.length > 1) {
  //       return true;
  //     } else if (this.instanceList.length == 1) {
  //       let odlInstanceHashId = this.instanceHashId;
  //       let newInstanceHashId = this.instanceList[0].keyHash;
  //       if (odlInstanceHashId != newInstanceHashId) {
  //         this.instanceHashId = newInstanceHashId;
  //         this.OnInstanceChange();
  //       }
  //     }
  //   }
  //   return false;
  // }

  // AllowToDisplayDropDown(
  //   dropDownItems: DropdownModel[],
  //   currentDropDownValue: string,
  //   callback: any
  // ) {
  //   if (dropDownItems) {
  //     if (dropDownItems.length > 1) {
  //       return true;
  //     } else if (dropDownItems.length == 1) {
  //       let odlHashId = currentDropDownValue;
  //       let newHashId = dropDownItems[0].keyHash;
  //       if (odlHashId != newHashId) {
  //         callback(this, newHashId);
  //       }
  //     }
  //   }
  //   return false;
  // }

  // SetInstanceDropDownValue(ref: any, newHashId: string) {
  //   ref.instanceHashId = newHashId;
  //   ref.OnInstanceChange();
  // }

  // SetCompanyDropDownValue(ref: any, newHashId: string) {
  //   ref.companyHashId = newHashId;
  //   ref.OnCompanyChange();
  // }

  ngOnDestroy(): void {
    this.authService.SaveToStorage(this.constructor.name + "_model", {
      instanceHashId: this.instanceHashId,
      companyHashId: this.companyHashId,
      svgHashId: this.sVGHashId,
      dashboardConfig: this.dashboardConfig
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/components/admin-dashboard-filter.component.ts